import transformProps from '@didi/webx-ui-utils/src/transform-props'
import config from '../../../views/wyc/config'

const props = {
  info: {
    type: Object,
    value: () => config,
  },
  pageConfig: {
    type: Object,
    value: () => ({
      index: {
        show: true, // xpub展示用
        style: {
          backgroundColor: 'rgb(253,241,222)',
          backgroundImage:
            'https://ut-static.udache.com/webx/ut/nSqi0nEtIckBw3GBYHDp4.png',
        },
        button: {
          text: '立即领取',
          gotoText: '立即使用',
        },
        link: 'https://didi.cn/wMB11DL',
        appLink: 'OneTravel://home/entrance',
        alipay_link: 'https://v.didi.cn/p/ZPDQZm7',
        title: '打车券免费领',
      },
      redPacket: {
        // style: {
        //   marginTop: undefined,
        // },
        _closeTitle: '滴滴出行专享',
      },
      resultB: {
        // b端结果页
        enable: false,
        show: false, // xpub展示用
        banner: {
          image: '',
          link: '',
        },
      },
      result: {
        // c端结果页
        show: false, // xpub展示用
        banner: {
          image:
            'https://ut-static.udache.com/webx/ut/OC55iaunb3trusGDNMhSD.png',
          link: 'https://didi.cn/MMvxe5Y',
        },
      },
      friday: {
        mockEnable: false, // xpub展示用
        enable: false,
        style: {
          backgroundImage:
            'https://ut-static.udache.com/webx/ut/8YrOXWcBKlWPZmLAB9k3E.png',
        },
        redPacket: {
          style: {
            marginTop: 380,
          },
        },
      },
      launchApp: {
        index: {
          show: false, // xpub展示用
          style: {
            backgroundImage:
              'https://ut-static.udache.com/webx/ut/-dwttjAFrPBvWPlBEJ2qQ.png',
            backgroundColor: 'rgb(255,249,199)',
          },
        },
        button: {
          text: '打开APP领取',
        },
        friday: {
          mockEnable: false, // xpub展示用
          enable: false,
          style: {
            backgroundImage: '',
            backgroundColor: '#FFFFFF',
          },
        },
      },
      rule: {
        link: '',
        style: {
          top: 40,
          color: '#FFFFFF',
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
      signVersion: {
        index: {
          show: false, // xpub展示用
          link: 'https://didi.cn/kr6xaR9',
          appLink: 'OneTravel://home/entrance',
          alipay_link: 'https://v.didi.cn/p/ZPDQZm7',
          style: {
            backgroundImage:
              'https://ut-static.udache.com/webx/ut/eDyjF5gNfy1bMMRBJAI5L.png',
          },
        },
        friday: {
          mockEnable: false, // xpub展示用
          enable: false,
          style: {
            backgroundImage: '',
          },
        },
        redPacket: {
          coupon: {
            style: {
              backgroundImage:
                'https://ut-static.udache.com/webx/ut/aza9naeohtVjr81p4lWTO.png',
            },
          },
          couponDiscount: 6,
          bonusRuleLink: '',
        },
        code: {
          titleTip: '省钱专属秘密通道',
          content: '保存二维码，明日再领100券包',
          btnText: '点击保存',
        },
        rule: {
          link: '',
          style: {
            top: 42,
            color: '#FFFFFF',
          },
        },
      },
    }),
  },
}

const mockIndex = {
  errno: 0,
  errmsg: '',
  traceid: '123',
  data: {
    group: {
      id: '1e32e345456454',
      status: 1,
    },
    sign_in_infos: [
      {
        count: 10,
        is_sign_in: true,
        is_today: false,
        max_count: 20,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 220,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 220,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 220,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 220,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: false,
        is_today: true,
        max_count: 220,
        desc: '没福利金，啥都没有',
      },
      {
        count: 110,
        is_sign_in: false,
        is_today: true,
        max_count: 220,
        desc: '没福利金，啥都没有',
      },
    ],
    activity_info: {
      id: 1,
      has_saved_poster: false,
      save_poster_bonus: 3,
      rewards: [
        {
          type: 'coupon',
          coupon: {
            type: 1,
            name: '加油福利券',
            usage_limit: '',
            valid_period: '',
            max_benefit_capacity: {
              value: 30,
              unit: '元',
            },
          },
        },
      ],
    },
  },
}

const { propsForView, propsForModel, propsForStory } = transformProps(props)

export { props, propsForView, propsForModel, propsForStory, mockIndex }
